import mostafaIsa from "../assets/mostafaIsa.jpeg";
import mohammadBarhamji from "../assets/mohammadBarhamji.jpeg";
import saleemAlaya from "../assets/saleemAlaya.jpeg";
import anasAlshugri from "../assets/anasAlshugri.jpeg";
import alaaShubat from "../assets/alaaShubat.jpeg";

const boardMembers = [
  {
    id: 1,
    name: "Mostafa Isa",
    image: mostafaIsa,
  },
  {
    id: 2,
    name: "Mohammad Barhamji",
    image: mohammadBarhamji,
  },
  {
    id: 3,
    name: "Saleem Alaya",
    image: saleemAlaya,
  },
  {
    id: 4,
    name: "Alaa Shubat",
    image: alaaShubat,
  },
  {
    id: 5,
    name: "Anas Alshugri",
    image: anasAlshugri,
  },
];

export default boardMembers;
